module.exports = __webpack_public_path__ + "static/laboratorio_1-aa82a3aa0938c1c8718025551119ab8b.jpg";